import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
const Surface = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { tag = 'div', elevation, className } = _param, rest = _object_without_properties(_param, [
        "tag",
        "elevation",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, _object_spread({
        ref: ref,
        tag: tag,
        themeSurface: elevation,
        className: c(`ds-${elevation}`, className)
    }, rest));
});
Surface.displayName = 'Surface';
export default Surface;
